export const translations = {
    en: {
      feedbackTitle: "How did we do?",
      feedbackTitles: {
        happy: "Great! What went well?",
        neutral: "How can we improve?",
        sad: "What was the problem?",
      },
      feedbackOptions: {
        happy: [
          { key: "answered", label: "I got my questions answered" },
          { key: "outcome", label: "I’m happy with the outcome" },
          { key: "easy", label: "Chat was easy to use" },
          { key: "other", label: "Something else" },
        ],
        neutral: [
          { key: "not_answered", label: "My questions weren’t answered" },
          { key: "unhappy", label: "I’m unhappy with the outcome" },
          { key: "difficult", label: "Chat was difficult to use" },
          { key: "other", label: "Something else" },
        ],
        sad: [
          { key: "not_answered", label: "My questions weren’t answered" },
          { key: "unhappy", label: "I’m unhappy with the outcome" },
          { key: "difficult", label: "Chat was difficult to use" },
          { key: "other", label: "Something else" },
        ],
      },
      feedbackPlaceholder: "Please provide your feedback here",
      cancel: "Cancel",
      sendFeedback: "Send Feedback",
    },
    es: {
      feedbackTitle: "¿Cómo fue tu experiencia?",
      feedbackTitles: {
        happy: "¡Genial! ¿Qué salió bien?",
        neutral: "¿Cómo podemos mejorar?",
        sad: "¿Cuál fue el problema?",
      },
      feedbackOptions: {
        happy: [
          { key: "answered", label: "Obtuve respuestas a mis preguntas" },
          { key: "outcome", label: "Estoy contento/a con el resultado" },
          { key: "easy", label: "El chat fue fácil de usar" },
          { key: "other", label: "Otra cosa" },
        ],
        neutral: [
          { key: "not_answered", label: "No se respondieron mis preguntas" },
          { key: "unhappy", label: "No estoy contento/a con el resultado" },
          { key: "difficult", label: "El chat fue difícil de usar" },
          { key: "other", label: "Otra cosa" },
        ],
        sad: [
            { key: "not_answered", label: "No se respondieron mis preguntas" },
            { key: "unhappy", label: "No estoy contento/a con el resultado" },
            { key: "difficult", label: "El chat fue difícil de usar" },
            { key: "other", label: "Otra cosa" },
        ],
      },
        feedbackPlaceholder: "Por favor, escribe tus comentarios aquí.",
        cancel: "Cancelar",
        sendFeedback: "Enviar",
    },
  };
  